import { Typography } from '@aloft/toolkit-sui';

import { usePropertyField } from './shared/usePropertyField.tsx';
import { readOnlyFieldProps } from './styles.ts';
import { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyField = ({
  columnIndex,
  field,
  colSpan = 1,
  isArv = false,
  control,
  getValues,
}: PropertyGridFieldProps) => {
  const { displayValue } = usePropertyField({ columnIndex, field, isArv, control, getValues });
  return <Typography {...readOnlyFieldProps(colSpan)}>{displayValue}</Typography>;
};
